import React from 'react';
import DevTools from '../../components/DevTools/DevTools';

const DevToolsPage = () => <DevTools />;

export default DevToolsPage;
